import { render, staticRenderFns } from "./DoctorList.vue?vue&type=template&id=c9f867b0&scoped=true"
import script from "./DoctorList.vue?vue&type=script&lang=js"
export * from "./DoctorList.vue?vue&type=script&lang=js"
import style0 from "./DoctorList.vue?vue&type=style&index=0&id=c9f867b0&prod&lang=scss&scoped=true"
import style1 from "./DoctorList.vue?vue&type=style&index=1&id=c9f867b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f867b0",
  null
  
)

export default component.exports